import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Dialog, ModalTitle, ModalButtons } from '~ui-kit';

import { completeOrderAndFetchTasks } from '~actions/transferActions';

const ConfirmCompleteModal = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onClose = () => {
    navigate(-1);
  };

  return (
    <Dialog onClose={onClose}>
      <ModalTitle
        title="Haluatko varmasti merkitä tämän tilauksen valmiiksi?"
        noClose
      />
      <ModalButtons
        closeButtonText="Palaa"
        confirmButtonText="Merkitse valmiiksi"
        onConfirmButtonClick={() => {
          dispatch(completeOrderAndFetchTasks(orderId));
          onClose();
        }}
      />
    </Dialog>
  );
};

export default ConfirmCompleteModal;
